import { Component, Input, OnInit } from '@angular/core';
import { currency } from 'app/constants/currency.constants';
import { HelperService } from 'app/services';

@Component({
  selector: 'app-repair-order-item',
  templateUrl: './repair-order-item.component.html',
  styleUrls: ['./repair-order-item.component.scss'],
})
export class RepairOrderItemComponent implements OnInit {
  @Input() service: any;
  @Input() isTreadDepthVisibleOnInvoice: boolean = false;
  @Input() isDeferredServiceEnabled: boolean = false;
  @Input() isFlatRateSubItemVisibleToCust: boolean = false;
  @Input() isFlatRateSubItemDescVisibleToCust: boolean = false;
  @Input() isFlatRateSubItemQtyVisibleToCust: boolean = false;
  @Input() displayExternalServiceNotes: boolean = false;
  @Input() appSettings: any = {};
  @Input() shopAppSettings: any = {};
  @Input() total: any;
  @Input() isEnhancedTSEnabled: boolean = false;
  @Input() isWarrantyNumberAddonEnabled: boolean = false;
  @Input() isPartWarrantiesEnabled: boolean = false;
  @Input() serviceAuthLabel: any;
  @Input() currentLang: string = 'en';
  @Input() isTireStorage2Enabled: boolean = false;

  usd: string = currency.USD;
  isShowPriceQty: boolean;
  lowerTreadDepthThreshold: string = '';

  constructor(public helperService: HelperService) { }

  ngOnInit() {
    this.isShowPriceQty = this.areAllDisplayHoursOff(this.service);
    this.lowerTreadDepthThreshold = this.appSettings.lowerTreadDepthThreshold;
  }

  checkApprovalStatus = () => this.appSettings && this.service && this.appSettings.displayAuthorizationDetails && this.service.approveConfirmation;

  areAllDisplayHoursOff(service: any): boolean {
    for (const item of service.items) {
      if (item.displayHoursOnOrder) {
        return false;
      }
    }
    return true;
  }

  getBundleSumWithoutHazmatFee(item): number {
    let sum = 0;
    if (item && item.subItems.length > 0) {
      for (const subItem of item.subItems) {
        if (subItem.type !== 'hazmatFee') {
          sum += subItem.subTotal || 0;
        }
      }
    }
    return sum;
  }

  getBundleSumWithHazmatFee(item): number {
    let sum = 0;
    if (item && item.subItems.length > 0) {
      for (const subItem of item.subItems) {
        if (subItem.type === 'hazmatFee') {
          sum += subItem.subTotal || 0;
        }
      }
    }
    return sum;
  }
}
